var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"search-view-lessonsearch"},[_c('router-link',{attrs:{"to":{
      name: 'lesson',
      params: {
        slug: _vm.slugfy(_vm.results.name),
        lesson: _vm.results.id,
        id: _vm.results.course
      }
    }}},[_c('img',{staticClass:"card-img-top img-fluid",attrs:{"src":_vm.results.thumbnail,"alt":_vm.results.name}}),_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title mt-2 text-center"},[_vm._v(_vm._s(_vm.results.name))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }